"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactButton = exports.REACT_BUTTON_TYPE = void 0;

var _tinymce = _interopRequireDefault(require("tinymce"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _settings = require("../utils/settings");

var REACT_BUTTON_TYPE = 'reactbutton';
exports.REACT_BUTTON_TYPE = REACT_BUTTON_TYPE;

var ReactButton = _tinymce.default.ui.Widget.extend({
  Defaults: {
    classes: 'widget btn react-button'
  },
  init: function init(settings) {
    this._super(settings);

    this.namespace = (0, _settings.getNamespace)(_tinymce.default.activeEditor);
  },
  getReactRootElem: function getReactRootElem() {
    return this.$("." + this.namespace, this.getEl())[0];
  },
  renderHtml: function renderHtml() {
    return "<div id=\"" + this._id + "\" class=\"" + this.classes + "\"><div class=\"" + this.namespace + "\"></div></div>";
  },
  postRender: function postRender() {
    this._super();

    var reactElement = this.settings.reactElement;

    _reactDom.default.render(reactElement, this.getReactRootElem());
  },
  remove: function remove() {
    _reactDom.default.unmountComponentAtNode(this.getReactRootElem());
  }
});

exports.ReactButton = ReactButton;

_tinymce.default.ui.Factory.add(REACT_BUTTON_TYPE, ReactButton);